{
  const debouceUpdateStyles = window.coolHelperFunctions.debounce((el) => updateStyles(el))

  function updateStyles(el){
    const target = document.querySelector(el.getAttribute('target'))

    if(target){
      let top = el.offsetTop
      // let adminBar = document.querySelector('#wpadminbar')
      // if(adminBar){
      //   top += adminBar.offsetHeight
      // }

      target.style.position = 'absolute',
      target.style.top = `${top}px`,
      target.style.left = `${el.offsetLeft}px`,
      target.style.width = `${el.offsetWidth}px`,

      el.style.height = `${target.offsetHeight}px`
    }
  }

  class moveElement extends HTMLElement {
    constructor(){
      super()
      this.loaded = false
    }

    connectedCallback() {
      if(this.loaded){
        return false
      } else {
        this.loaded = true
        this.style.display = 'block'
        // updateStyles(this)
        document.addEventListener('DOMContentLoaded', () => updateStyles(this))
        window.addEventListener('resize', () => debouceUpdateStyles(this))
        window.addEventListener('scroll', () => debouceUpdateStyles(this))
        setTimeout(() => updateStyles(this), 500)
      }
    }
  }

  customElements.define("move-element", moveElement)
}